import { dataByProduct } from './data';

export const getDataByProduct = (slug: string) => {
  const lowerSlug = slug.toLocaleLowerCase();

  if (!(lowerSlug in dataByProduct)) return null;

  return dataByProduct[lowerSlug as keyof typeof dataByProduct];
};
